/**
 * FairwayBid – Reichweite eines Anbieters
 *
 * Der günstigste Preis nützt einer Anlage wenig, wenn der Anbieter keine
 * eigenen Monteure schickt und bei einer Störung im Saisonbetrieb drei Tage
 * braucht. Diese Angaben stehen im Händlerprofil – aber dort schaut niemand
 * nach, während er Preise vergleicht.
 *
 * Deshalb bringen wir sie an die Stelle, an der entschieden wird: in den
 * Angebotsvergleich, eine Zeile je Anbieter.
 */

export const SERVICE_LABELS = {
  delivery: 'Lieferung',
  installation: 'Montage',
  training: 'Einweisung',
  maintenance: 'Wartung',
  spare_parts: 'Ersatzteile',
  onsite_service: 'Vor-Ort-Service',
  trade_in: 'Inzahlungnahme',
  financing: 'Finanzierung',
  rental: 'Vermietung',
  disposal: 'Entsorgung',
  other: 'Sonstiges',
};

export const COUNTRY_LABELS = {
  DE: 'Deutschland',
  AT: 'Österreich',
  CH: 'Schweiz',
  NL: 'Niederlande',
  FR: 'Frankreich',
  other_eu: 'weiteres europäisches Land',
};

// Was eine Anlage im Saisonbetrieb wirklich interessiert – in dieser Reihenfolge.
export const KEY_SERVICES = ['installation', 'onsite_service', 'maintenance', 'spare_parts'];

const publicData = user => user?.attributes?.profile?.publicData || {};

export const getRegions = user => {
  const value = publicData(user).delivery_regions;
  return Array.isArray(value) ? value.filter(Boolean) : [];
};

export const getServices = user => {
  const value = publicData(user).services_offered;
  return Array.isArray(value) ? value.filter(Boolean) : [];
};

export const deliversTo = (user, country) => {
  if (!country) return null;
  const regions = getRegions(user);
  if (regions.length === 0) return null;
  return regions.includes(country);
};

/**
 * Kurzfassung der Reichweite für eine Spalte im Angebotsvergleich.
 *
 * @param {Object} user Händlerprofil
 * @param {string} country Lieferland der Anfrage
 * @returns {string} z. B. "Liefert nach Deutschland · Montage, Vor-Ort-Service"
 */
export const describeCoverage = (user, country) => {
  const covers = deliversTo(user, country);
  const services = getServices(user).filter(s => KEY_SERVICES.includes(s));

  const parts = [];
  if (covers === true) {
    parts.push(`Liefert nach ${COUNTRY_LABELS[country] || country}`);
  } else if (covers === false) {
    parts.push(`${COUNTRY_LABELS[country] || country} nicht im Liefergebiet`);
  }

  if (services.length > 0) {
    parts.push(
      KEY_SERVICES.filter(s => services.includes(s))
        .map(s => SERVICE_LABELS[s])
        .join(', ')
    );
  }

  return parts.length > 0 ? parts.join(' · ') : 'keine Angabe';
};
